import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import AdmicityGroupFilterSelect from '../../../shared-components/AdmicityGroupFilterSelect';
import AdmicityTable from '../../../shared-components/AdmicityTable';
import {Box, Button} from '@mui/material';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import {
    useCreateFormAssignmentMutation,
    useDeleteFormAssignmentsMutation,
    useGetFormAssignmentsQuery
} from '../../../api/services/formAssignmentsService';
import withPagination from '../../../hoc/pagination/withPagination';
import {useGetGroupFiltersQuery} from '../../../api/services/groupService';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import {showSnackbar} from '../../../AppLayout/ApplicationSlice';
import {useDispatch} from 'react-redux';

const tableProps = {
    columns: [
        {
            field: 'displayName',
            headerName: 'Name',
            editable: false,
            sortable: false,
            flex: 1,
        }
    ]
};

const PrivateFormSettings = ({formId, onAddRecipient}) => {
    const [filterId, setFilterId] = useState('');
    const dispatch = useDispatch();
    const {data} = useGetGroupFiltersQuery();
    const [createFormAssignment] = useCreateFormAssignmentMutation();
    const [deleteFormAssignments, {
        isSuccess: isDeleteFormAssignmentSuccess,
        isError: isDeleteFormAssignmentError
    }] = useDeleteFormAssignmentsMutation();
    const [selectedAssignmentIds, setSelectedAssignmentIds] = useState([]);

    useEffect(() => {
        return () => {
            setFilterId('');
        };
    }, []);

    useEffect(() => {
        if (isDeleteFormAssignmentError || isDeleteFormAssignmentSuccess) {
            if (isDeleteFormAssignmentError) {
                dispatch(showSnackbar({message: 'Failed to delete form assignment', severity: 'error'}));
            }
            if (isDeleteFormAssignmentSuccess) {
                setSelectedAssignmentIds([]);
            }
        }
    }, [isDeleteFormAssignmentSuccess, isDeleteFormAssignmentError]);

    const handleAddRecipient = async () => {
        await createFormAssignment({filterId, formId});
        setFilterId('');
    };

    const Table = withPagination(AdmicityTable,
        useGetFormAssignmentsQuery,
        {formId},
        {},
        (count) => {
            if (onAddRecipient) {
                onAddRecipient(count);
            }
        });

    return (
        <>
            <Box display="flex" alignItems={'center'} flexWrap={'wrap'}>
                <AdmicityGroupFilterSelect
                    sx={{
                        marginLeft: 2,
                        marginRight: 2
                    }}
                    data={data?.modules}
                    value={filterId}
                    onChange={setFilterId}
                />
                <div>
                    <Button
                        onClick={handleAddRecipient}
                        variant="contained"
                        disabled={!filterId}
                    >
                        Add recipients
                    </Button>
                </div>
            </Box>
            <Table
                columns={tableProps.columns}
                checkboxSelection
                rowSelectionModel={selectedAssignmentIds}
                handleRowSelection={setSelectedAssignmentIds}
                toolbarActions={
                    selectedAssignmentIds?.length > 0
                        ? [
                            {
                                type: 'button',
                                title: 'Delete',
                                icon: <DeleteForeverRoundedIcon/>,
                                onClick: async () =>
                                    await deleteFormAssignments({
                                        formAssignmentIds: selectedAssignmentIds,
                                        formId
                                    })
                            }
                        ]
                        : []
                }
                noRowsOverlay={{
                    icon: <PersonOffRoundedIcon/>,
                    text: 'No recipients has been added'
                }}
                sx={{
                    borderBottom: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                    borderRadius: 0
                }}
            />
        </>
    );
};

PrivateFormSettings.propTypes = {
    formId: PropTypes.number,
    onAddRecipient: PropTypes.func,
};

export default PrivateFormSettings;
